import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Box, Button, Card, CardContent, GridLegacy, TextField } from "@mui/material";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper";

export default function CustomFonts(props) {
  const { register } = useFormContext();
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({ name: "custom_fonts" });

  const customFontsErrors = props?.errors?.custom_fonts;

  // Adds custom fonts to the page so the fonts can be previewed in JSFontFamilyComponent
  useEffect(() => {
    fields?.forEach((font) => {
      const fontPath = `${import.meta.env.VITE_AZURE_STORAGE}image_uuids/${font.jamezzFileUuid}/${
        font.jamezzFileUuid
      }.${font.jamezzFileExtension}`;
      const fontFace = new FontFace(font.fontFamily, `url(${fontPath})`);

      if (!document.fonts.has(fontFace)) {
        document.fonts.add(fontFace);
      }
    });
  }, [fields]);

  return (
    <Box>
      <GridLegacy item xs={12}>
        <h3>
          <TranslationWrapper tDefault={"Custom fonts"} tKey={"vestigingen.form.branding.headers.customfonts"} />
        </h3>
      </GridLegacy>

      {fields?.map((field, index) => {
        return (
          <Card key={index} style={{ marginBottom: "10px" }}>
            <CardContent>
              <GridLegacy container key={index} spacing={2}>
                <GridLegacy item xs={12}>
                  Font #{index + 1}
                </GridLegacy>
                <GridLegacy
                  item
                  md={6}
                  style={{
                    color: "rgba(0, 0, 0, 0.54)",
                    fontWeight: 400,
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontSize: "1rem",
                  }}
                  xs={12}
                >
                  FontFamily: (e.g. AmsiPro-Regular)
                </GridLegacy>
                <GridLegacy item md={6} xs={12}>
                  <TextField
                    error={customFontsErrors ? customFontsErrors[index]?.fontFamily : null}
                    key={field.id}
                    placeholder={"fontFamily"}
                    style={
                      customFontsErrors && customFontsErrors[index]?.fontFamily
                        ? {
                            backgroundColor: "rgb(254 236 236 / 79%)",
                            width: "100%",
                          }
                        : {
                            backgroundColor: "#f7f7f7",
                            width: "100%",
                          }
                    }
                    {...register(`custom_fonts.${index}.fontFamily`, { required: true })}
                  />
                </GridLegacy>
                <GridLegacy
                  item
                  md={6}
                  style={{
                    color: "rgba(0, 0, 0, 0.54)",
                    fontWeight: 400,
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontSize: "1rem",
                  }}
                  xs={12}
                >
                  FontWeight: (e.g. normal or 400)
                </GridLegacy>
                <GridLegacy item md={6} xs={12}>
                  <TextField
                    error={customFontsErrors ? customFontsErrors[index]?.fontWeight : null}
                    key={field.id}
                    placeholder={"fontWeight"}
                    style={
                      customFontsErrors && customFontsErrors[index]?.fontWeight
                        ? {
                            backgroundColor: "rgb(254 236 236 / 79%)",
                            width: "100%",
                          }
                        : {
                            backgroundColor: "#f7f7f7",
                            width: "100%",
                          }
                    }
                    {...register(`custom_fonts.${index}.fontWeight`, { required: true })}
                  />
                </GridLegacy>
                <GridLegacy
                  item
                  md={6}
                  style={{
                    color: "rgba(0, 0, 0, 0.54)",
                    fontWeight: 400,
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontSize: "1rem",
                  }}
                  xs={12}
                >
                  FontStyle: (e.g. normal or italic)
                </GridLegacy>
                <GridLegacy item md={6} xs={12}>
                  <TextField
                    error={customFontsErrors ? customFontsErrors[index]?.fontStyle : null}
                    key={field.id}
                    placeholder={"fontStyle"}
                    style={
                      customFontsErrors && customFontsErrors[index]?.fontStyle
                        ? {
                            backgroundColor: "rgb(254 236 236 / 79%)",
                            width: "100%",
                          }
                        : {
                            backgroundColor: "#f7f7f7",
                            width: "100%",
                          }
                    }
                    {...register(`custom_fonts.${index}.fontStyle`, { required: true })}
                  />
                </GridLegacy>
                <GridLegacy
                  item
                  md={6}
                  style={{
                    color: "rgba(0, 0, 0, 0.54)",
                    fontWeight: 400,
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontSize: "1rem",
                  }}
                  xs={12}
                >
                  FontDisplay: (e.g. auto, swap)
                </GridLegacy>
                <GridLegacy item md={6} xs={12}>
                  <TextField
                    error={customFontsErrors ? customFontsErrors[index]?.fontDisplay : null}
                    key={field.id}
                    placeholder={"fontDisplay"}
                    style={
                      customFontsErrors && customFontsErrors[index]?.fontDisplay
                        ? {
                            backgroundColor: "rgb(254 236 236 / 79%)",
                            width: "100%",
                          }
                        : {
                            backgroundColor: "#f7f7f7",
                            width: "100%",
                          }
                    }
                    {...register(`custom_fonts.${index}.fontDisplay`, { required: true })}
                  />
                </GridLegacy>
                <GridLegacy
                  item
                  md={6}
                  style={{
                    color: "rgba(0, 0, 0, 0.54)",
                    fontWeight: 400,
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontSize: "1rem",
                  }}
                  xs={12}
                >
                  File
                </GridLegacy>
                <GridLegacy item md={6} xs={12}>
                  <input
                    key={field.id}
                    placeholder={"file"}
                    type={"file"}
                    {...register(`custom_fonts.${index}.file`)}
                  />
                </GridLegacy>
              </GridLegacy>
            </CardContent>
          </Card>
        );
      })}

      <AddNewFontForm append={append} />
    </Box>
  );
}

function AddNewFontForm({ append }) {
  return (
    <>
      {/* <Typography style={{ marginTop: "15px", textTransform: "none" }} variant={"h6"}>
        Add new font
      </Typography> */}

      <Button
        onClick={() => {
          let uuid = "";
          if (window.crypto?.randomUUID) {
            uuid = window.crypto.randomUUID();
          } else {
            uuid = makeid(32);
          }

          append({ id: uuid, fontFamily: "" });
        }}
        style={{ textTransform: "none" }}
        variant={"contained"}
      >
        Add new font
      </Button>
    </>
  );
}

export function makeid(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
